export interface StructureType {
  id: string;
  client: string;
  name: string;
  is_preset: boolean;
  created_by: string | null;
  created_at: string;
  updated_by: string | null;
  updated_at: string;
}

export interface StructureTask {
  id: string;
  client: string;
  structure_type: string;
  structure_type_name: string;
  name: string;
  created_by: string | null;
  created_at: string;
  updated_by: string | null;
  updated_at: string;
}

export interface StructureTaskModule {
  id: string;
  client: string;
  task: string;
  task_name: string;
  name: string;
  description: string;
  module_type: 'video';
  video: string | null;
  video_url: string | null;
  required_users?: Array<{
    id: number;
    first_name: string;
    last_name: string;
    email: string;
  }>;
  watched_by_current_user?: boolean;
  watched_at_current_user?: string | null;
  required_watch_status?: Array<{
    user_id: number;
    name: string;
    email: string;
    watched: boolean;
    watched_at: string | null;
  }>;
  created_by: string | null;
  created_at: string;
  updated_by: string | null;
  updated_at: string;
}

export type StructureTypeFormData = {
  name: string;
  is_preset: boolean;
};

export type StructureTaskFormData = {
  name: string;
  structure_type: string;
};

export type StructureTaskModuleFormData = {
  name: string;
  description: string;
  task: string;
  video: File | null;
  required_user_ids: number[];
};

export interface ClientUserOption {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
}

export const PRESET_STRUCTURE_TYPES = [
  'Residential',
  'Multi-Family',
  'Commercial',
  'Industrial',
  'Medical',
  'Education',
  'Hospitality',
  'Retail',
] as const;
